import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { posts } from '@/mocks/posts';
import { channels } from '@/mocks/channels';
import PostCard from '@/components/feature/PostCard';
import SectionHeading from '@/components/feature/SectionHeading';

const tabs = [{ slug: 'all', name: '全部' }, ...channels.slice(0, 5)];

export default function ContentStream() {
  const [searchParams] = useSearchParams();
  const keyword = (searchParams.get('q') ?? '').trim();
  const [activeTab, setActiveTab] = useState('all');

  const filtered = useMemo(() => {
    let list = posts;
    if (activeTab !== 'all') {
      list = list.filter((post) => post.channel === activeTab);
    }
    if (keyword) {
      const query = keyword.toLowerCase();
      list = list.filter(
        (post) =>
          post.title.toLowerCase().includes(query) ||
          post.excerpt.toLowerCase().includes(query) ||
          post.tags.some((tag) => tag.toLowerCase().includes(query)),
      );
    }
    return list.sort((a, b) => b.heat - a.heat);
  }, [activeTab, keyword]);

  const [featured, ...rest] = filtered;

  return (
    <section id="stream" className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="CONTENT STREAM"
        title={keyword ? `关于「${keyword}」的搜索结果` : '精选内容流'}
        desc={
          keyword
            ? `共找到 ${filtered.length} 条相关内容，换个关键词或者切个专栏试试看。`
            : '按热度排序的近期内容，从热瓜到段子，随便挑一条都能打发几分钟。'
        }
      />

      <div className="mb-8 flex flex-wrap items-center gap-2">
        {tabs.map((tab) => (
          <button
            key={tab.slug}
            type="button"
            onClick={() => setActiveTab(tab.slug)}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
              activeTab === tab.slug
                ? 'bg-primary-500 font-medium text-background-50'
                : 'border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-foreground-400">
            <i className="ri-emotion-sad-line w-7 h-7 flex items-center justify-center text-3xl" />
          </span>
          <h3 className="mt-4 font-heading text-lg text-foreground-900">暂时没搜到这个瓜</h3>
          <p className="mt-2 text-sm text-foreground-600">
            换个关键词试试，或者直接去热瓜榜逛逛，那里一定有你的菜。
          </p>
        </div>
      ) : (
        <div className="space-y-6">
          <PostCard post={featured} variant="wide" />
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {rest.map((post) => (
              <PostCard key={post.id} post={post} />
            ))}
          </div>
        </div>
      )}
    </section>
  );
}